import { create } from "zustand";

export const useSuccessMessageStore = create((set) => ({
    message: null,
    callback: null,

    setSuccess: (message, callback) => set({ message, callback }),

    reset: () => set({ message: null, callback: null }),
}));
